import core from '@/helpers/client'

const onlineCategoryService = {
  async headOnlineCategoryAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories`,
      params
    )
    return result
  },
  async getOnlineCategoryListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories`,
      params
    )
    return result
  },
  async getOnlineCategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/treenode`,
      params
    )
    return result
  },
  async getMappingOnlineCategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/mappingtreenode`,
      params
    )
    return result
  },
  async getOnlineCategoryDetailAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/${id}`,
      params
    )
    return result
  },
  async getOnlineProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/${id}/skus`
    );
    return result;
  },
  async createOnlineCategoryAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories`,
      model
    )
    return result
  },
  async updateOnlineCategoryAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/${id}`,
      model
    )
    return result
  },
  async updateAllOnlineCategoryApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/${id}/approval`,
      model
    )
    return result
  },
  async deleteOnlineCategoryByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/OnlineCategories/delete/${id}`
    )
    return result
  },
}
export default onlineCategoryService
